<div id="blog-new" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg" fxLayout="row" fxLayoutAlign="space-between center">

      <!-- APP TITLE -->
      <div fxLayout="row" fxLayoutAlign="start center">

        <button class="mr-0 mr-sm-16" mat-icon-button [routerLink]="'/pages/blog'">
          <mat-icon>arrow_back</mat-icon>
        </button>

        <div class="product-image mr-8 mr-sm-16" *fuseIfOnDom>
          <!--<img [src]="'assets/images/blog.svg'">-->
          <mat-icon style="font-size: 56px">dashboard</mat-icon>
        </div>

        <div fxLayout="column" fxLayoutAlign="start start"
          *fuseIfOnDom>
          <div class="h2">
            {{'blog.new_blog' | translate}}
          </div>
          <div class="subtitle secondary-text">
            <span>{{'blog.blog_detail' | translate}}</span>
          </div>
        </div>
      </div>
      <!-- / APP TITLE -->

      <button mat-raised-button
        class="save-product-button mat-white-bg mt-16 mt-sm-0"
        (click)="addBlog(true)">
        <span>{{'main.add' | translate}}</span>
      </button>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">

      <!-- CONTENT -->
      <div class="content">
        <div class="example">
          <div class="radio-select">
            <mat-radio-group >
              <mat-radio-button value="small" [checked]="true" (change)="selectBlog('small')">{{'blog.small' | translate}}</mat-radio-button>
              <mat-radio-button value="full" (change)="selectBlog('full')">{{'blog.full' | translate}}</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="example-page" [ngClass]="{'full-page-style': radio === 'full'}">
            @if (radio === 'small'  && blogForm.controls['type'].value !== 'custom') {
              <div class="blog-block">
                @if (info.image) {
                  <img src="{{info?.image}}" class="image">
                }
                @if (videoUrl && !info.image) {
                  <div >
                    <iframe [src]="videoUrl" class="video">
                    </iframe>
                  </div>
                }
                <div class="header-three">
                  <div class="part-1" [style.backgroundColor]="opacityColor">
                    {{info?.header}}
                  </div>
                  <div class="part-2">
                  </div>
                  <div class="part-3">
                  </div>
                </div>
                <div class="text-info">
                  <div class="title">
                    {{info?.title}}
                  </div>
                  @if (info.text) {
                    <div class="text" [innerHTML]="info.text">
                    </div>
                  }
                  @if (info.link) {
                    <div class="link">
                      <a href="{{info.link | linkHttp}}" target="_blank">{{info.linkLabel}}</a>
                    </div>
                  }
                </div>
              </div>
            }
            @if (radio === 'small' && blogForm.controls['type'].value === 'custom') {
              <div>
                <div class="new-blog">
                  @if (info.image) {
                    <div  class="image">
                      <img src="{{info?.image}}">
                    </div>
                  }
                  @if (videoUrl && !info.image) {
                    <div >
                      <iframe [src]="videoUrl" class="video">
                      </iframe>
                    </div>
                  }
                  <app-header-one [color]="'#A3A3A3'" [title]="info.date" [date]="'Blog'"
                  [textColor]="'black'" [type]="'blog'"></app-header-one>
                  <div class="main-info" [ngClass]="{'no-image' : !info.image && !videoUrl}">
                    <div class="main-info-title">
                      {{info?.title}}
                    </div>
                    @if (info.text) {
                      <div class="text" [innerHTML]="info.text">
                      </div>
                    }
                    @if (info.link && ((!info.text && info.image) || (info.text && !info.image))) {
                      <div class="link">
                        <a href="{{info.link | linkHttp}}" target="_blank">{{info.linkLabel}}</a>
                      </div>
                    }
                  </div>
                </div>
                @if (info) {
                  <div class="block-footer">
                    <div class="block-footer-1">
                    </div>
                    <div class="block-footer-2">
                      <div class="block-footer-2-1">
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
            @if (radio === 'full') {
              <div class="full-blog">
                @if (info.image) {
                  <img src="{{info?.image}}" class="image">
                }
                @if (videoUrl && !info.image) {
                  <div >
                    <iframe [src]="videoUrl" frameborder="0" allow="encrypted-media" allowfullscreen class="video"></iframe>
                  </div>
                }
                <div class="header-three">
                  <div class="part-1" [style.backgroundColor]="opacityColor">
                    {{info?.header}}
                  </div>
                  <div class="part-2">
                  </div>
                  <div class="part-3">
                  </div>
                </div>
                <div class="text-info">
                  @if (videoUrl && info.image) {
                    <div class="video-container">
                      <iframe [src]="videoUrl" class="video">
                      </iframe>
                    </div>
                  }
                  <div class="title">
                    {{info?.fullTitle}}
                  </div>
                  @if (info.fullText) {
                    <div class="text" [innerHTML]="info.fullText">
                    </div>
                  }
                  @if (info.link) {
                    <div class="link">
                      <a href="{{info.link | linkHttp}}" target="_blank">{{info.linkLabel}}</a>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
        <div class="blog-form">
          <form [formGroup]="blogForm">
            <mat-form-field>
              <mat-label>{{'blog.header' | translate}}</mat-label>
              <input matInput formControlName="header">
              <!--<mat-error *ngIf="blogForm?.title.required">-->
              <!--Title is required-->
            <!--</mat-error>-->
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{'blog.title' | translate}}</mat-label>
            <input matInput formControlName="title">
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{'blog.full_title' | translate}}</mat-label>
            <textarea matInput formControlName="fullTitle"></textarea>
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{'blog.text' | translate}}</mat-label>
            <input matInput formControlName="text">
          </mat-form-field>
          <!--<mat-form-field>-->
          <!--<textarea matInput placeholder="Full text" formControlName="fullText"></textarea>-->
        <!--</mat-form-field>-->
        <div style="width: 90%; color: gray">
          <div>{{'blog.full_text' | translate}}</div>
          <!--<app-ngx-editor [config]="config" formControlName="fullText"-->
        <!--id="descriptionEditor"></app-ngx-editor>-->
        <quill-editor formControlName="fullText">
        </quill-editor>
      </div>
      <mat-form-field>
        <mat-label>{{'blog.link' | translate}}</mat-label>
        <input matInput formControlName="link">
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{'blog.link_label' | translate}}</mat-label>
        <input matInput formControlName="linkLabel">
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{'blog.image' | translate}}</mat-label>
        <input matInput formControlName="image">
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{'blog.video' | translate}}</mat-label>
        <input matInput formControlName="video">
      </mat-form-field>
      <mat-form-field class="date">
        <mat-label>{{'blog.from' | translate}}</mat-label>
        <input matInput readonly formControlName="dateFrom">
        <input [matDatepicker]="dt1" matInput readonly style="display: none">
        <mat-datepicker-toggle matSuffix [for]="dt1"></mat-datepicker-toggle>
        <mat-datepicker #dt1 disabled="false" (closed)="closePicker('dateFrom', dt1)"></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="date">
        <mat-label>{{'blog.to' | translate}}</mat-label>
        <input matInput readonly formControlName="dateTo">
        <input [matDatepicker]="dt2" matInput readonly style="display: none">
        <mat-datepicker-toggle matSuffix [for]="dt2"></mat-datepicker-toggle>
        <mat-datepicker #dt2 disabled="false" (closed)="closePicker('dateTo', dt2)"></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{'blog.type' | translate}}</mat-label>
        <mat-select formControlName="type">
          <mat-option [value]="'pfefferstern'">
            Footer-Information
          </mat-option>
          <mat-option [value]="'custom'" >
            Custom
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{'blog.visibility' | translate}}</mat-label>
        <mat-select formControlName="visible">
          <mat-option [value]="'internal'">
            {{'blog.internal' | translate}}
          </mat-option>
          <mat-option [value]="'public'" >
            {{'blog.public' | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{'blog.category' | translate}}</mat-label>
        <mat-select formControlName="blogTypeId">
          @for (item of category; track item.id) {
            <mat-option [value]="item.id">
              {{item.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (blogForm.get('visible').value === 'internal') {
        <mat-form-field>
          <mat-label>{{'blog.tg' | translate}}</mat-label>
          <mat-select formControlName="targetGroup" multiple>
            @for (group of targetGroups; track group.id; let i = $index) {
              <mat-optgroup  >
                    <div style="cursor: pointer;display: flex;
    align-items: center;" (click) = "setAll(group.name, i)">
                  @if (group.selected) {
                    <i class="material-icons">
                      check_box
                    </i>
                  }
                  @if (!group.selected) {
                    <i class="material-icons">
                      check_box_outline_blank
                    </i>
                  }
                  <b style="font-size: large;">{{group.name}}</b></div>
                  @for (tg of group.data; track tg) {
                    <mat-option [value]="tg.id">
                      {{tg.ageMask}}
                    </mat-option>
                  }
                </mat-optgroup>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (blogForm.get('visible').value === 'internal') {
          <mat-form-field>
            <mat-label>{{'blog.tag' | translate}}</mat-label>
            <mat-select formControlName="tag" multiple>
              @for (tg of tags; track tg) {
                <mat-option [value]="tg.id">
                  {{tg.name}} ({{tg.organization.name}})
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (blogForm.get('visible').value === 'internal') {
          <mat-form-field>
            <mat-label>{{'blog.role' | translate}}</mat-label>
            <mat-select formControlName="userRole" multiple>
              @for (tg of frontRoles; track tg) {
                <mat-option [value]="tg.id">
                  {{('main.' + tg.name) | translate}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        <mat-form-field>
          <mat-label>{{'user.lang' | translate}}</mat-label>
          <mat-select formControlName="lang">
            <mat-option [value]="'en'">
              {{'English' | translate}}
            </mat-option>
            <mat-option [value]="'de'" >
              {{'Germany' | translate}}
            </mat-option>
            <mat-option [value]="'fr'" >
              {{'French"' | translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>
      @if (platforms && platforms.length && platforms.length > 1) {
        <div class="platform">
          <mat-form-field>
            <mat-label>{{'event.platforms' | translate}}</mat-label>
            <mat-select multiple (selectionChange)="changePlatforms($event)"
              [value]="selectedPlatforms">
              @for (plat of platforms; track plat.id) {
                <mat-option [value]="plat.id">
                  {{plat.title}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      <div class="cropper">
        <cropper [avatar]="''" [page]="'blog-new'" [defaultRatio]="true" (sendImg)="setImg($event)"></cropper>
      </div>
    </div>
  </div>
  <!-- / CONTENT -->

</div>
<!-- / CONTENT CARD -->

</div>
<!-- / CENTER -->
</div>

